// pp-credito-solicitud.js — Onboarding de crédito (Fase 1, catálogo alineado a
// legal 2026-08-03): el cliente elegible sube sus documentos KYC (CSF, INE,
// comprobante de domicilio, y —persona moral— acta constitutiva y poder del
// representante legal) más el correo del representante (corporativo si
// moral, personal si física).
//
// Visibilidad: el botón que abre el modal SOLO se revela cuando
// GET /apps/crm/customer-credito devuelve state === 'elegible'. Se lee vía
// window.PPAccount.get('customer-credito') — la MISMA promesa cacheada que usa
// pp-credito.js, así que no duplicamos el fetch. En construyendo/en_revision/
// con_credito/suspendido/found:false el componente se queda oculto para siempre
// (sin listeners, sin más red).
//
// Pre-llenado fiscal: GET /apps/crm/customer-fiscal (lazy — solo al abrir el
// modal por primera vez), vía la misma capa PPAccount. Usa los campos
// top-level del perfil default: razon_social, rfc, cp_fiscal. found:false →
// guía al cliente a /pages/cliente-facturacion (no bloquea el envío: el KYC de
// esta Fase 1 son los documentos, no el perfil fiscal).
//
// Submit: multipart/form-data → POST /apps/crm/customer-credito-solicitud.
// Contrato exacto en snippets/pp-credito-solicitud.liquid (comentario de
// cabecera) y docs/db/crm-nucleo.md del monorepo backend (Task 3).
//
// Catálogo de documentos: hardcodeado en el snippet Liquid (sin GET de
// catálogo en Fase 1). Este JS solo LEE el DOM (data-pp-credsol-doc /
// data-aplica / data-requerido) — no necesita conocer los 5 keys aquí.

(function () {
  'use strict';

  var ENDPOINT = '/apps/crm/customer-credito-solicitud';
  var CREDITO_PATH = 'customer-credito';
  var FISCAL_PATH = 'customer-fiscal';
  var FISCAL_PAGE_URL = '/pages/cliente-facturacion';

  // Espejo EXACTO del server (credito-onboarding.ts): FILE_SIZE_LIMIT_BYTES +
  // ALLOWED_MIME_TYPES. Esta validación es solo UX — el server re-valida
  // siempre; si difieren, el server manda.
  var MAX_SIZE = 10485760; // 10 MiB
  var ALLOWED_MIME = ['application/pdf', 'image/jpeg', 'image/png', 'image/webp'];

  var root = document.querySelector('[data-pp-credsol]');
  var openBtn = document.querySelector('[data-pp-credsol-open]');
  var modal = document.querySelector('[data-pp-credsol-modal]');
  if (!root || !openBtn || !modal) return;

  // En el editor del theme no hay sesión de cliente real — nunca mostrar.
  if (window.Shopify && window.Shopify.designMode) return;

  // data-t-fiscal-found-note → root.dataset.tFiscalFoundNote (dataset NO
  // recorta el prefijo "t-"). Re-mapeamos a claves cortas aquí una sola vez.
  var ds = root.dataset;
  var t = {
    fiscalFoundNote: ds.tFiscalFoundNote,
    fiscalMissingTitle: ds.tFiscalMissingTitle,
    fiscalMissingBody: ds.tFiscalMissingBody,
    fiscalMissingCta: ds.tFiscalMissingCta,
    razonSocial: ds.tRazonSocial,
    rfc: ds.tRfc,
    cpFiscal: ds.tCpFiscal,
    submit: ds.tSubmit,
    submitting: ds.tSubmitting,
    successPartialBody: ds.tSuccessPartialBody,
    fileUploaded: ds.tFileUploaded,
    docMissing: ds.tDocMissing,
    errUploadFailed: ds.tErrUploadFailed,
    errGeneric: ds.tErrGeneric,
    errSinEmpresa: ds.tErrSinEmpresa,
    errMemberRevoked: ds.tErrMemberRevoked,
    errPrivacidad: ds.tErrPrivacidad,
    errMimeInvalido: ds.tErrMimeInvalido,
    errSizeExcedido: ds.tErrSizeExcedido,
    errTipoInvalido: ds.tErrTipoInvalido,
    correoLabelMoral: ds.tCorreoLabelMoral,
    correoLabelFisica: ds.tCorreoLabelFisica,
    errCorreoRequerido: ds.tErrCorreoRequerido,
    errCorreoInvalido: ds.tErrCorreoInvalido
  };

  var form = modal.querySelector('[data-pp-credsol-form]');
  var closeEls = modal.querySelectorAll('[data-pp-credsol-close], [data-pp-credsol-cancel]');
  var doneBtn = modal.querySelector('[data-pp-credsol-done]');
  var successEl = modal.querySelector('[data-pp-credsol-success]');
  var submitBtn = modal.querySelector('[data-pp-credsol-submit]');
  var submitTextEl = modal.querySelector('[data-pp-credsol-submit-text]');
  var bannerEl = modal.querySelector('[data-pp-credsol-banner]');
  var privacyInput = modal.querySelector('[data-pp-credsol-privacidad]');
  var fiscalBodyEl = modal.querySelector('[data-pp-credsol-fiscal-body]');
  var tipoInputs = Array.prototype.slice.call(modal.querySelectorAll('[data-pp-credsol-tipo]'));
  var docEls = Array.prototype.slice.call(modal.querySelectorAll('[data-pp-credsol-doc]'));
  var empresaEl = modal.querySelector('[data-pp-credsol-empresa]');
  var correoInput = modal.querySelector('[data-pp-credsol-correo-input]');
  var correoLabelEl = modal.querySelector('[data-pp-credsol-correo-label]');
  var correoErrorEl = modal.querySelector('[data-pp-credsol-correo-error]');

  // tipo(key) → { file: File|null } — sobrevive a cambios de tipo_persona
  // (si el cliente cambia de moral a física y regresa, no pierde lo ya adjunto).
  var files = {};
  docEls.forEach(function (el) {
    files[el.getAttribute('data-pp-credsol-doc')] = null;
  });

  var fiscalLoaded = false;

  function get(path) {
    return (window.PPAccount && typeof window.PPAccount.get === 'function')
      ? window.PPAccount.get(path)
      : fetch('/apps/crm/' + path, { method: 'GET', credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
  }

  function fmtSize(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  function currentTipo() {
    var checked = tipoInputs.filter(function (i) { return i.checked; })[0];
    return checked ? checked.value : 'moral';
  }

  // ── Visibilidad por tipo_persona ────────────────────────────────────────
  // También actualiza la etiqueta del correo del representante: corporativo
  // para moral, personal para física (mismo campo `correo_representante` en
  // ambos casos — solo cambia el copy, no el name del input).
  function applyTipoVisibility() {
    var tipo = currentTipo();
    docEls.forEach(function (el) {
      var aplica = el.getAttribute('data-aplica');
      el.hidden = !(aplica === 'ambos' || aplica === tipo);
    });
    // Datos de la empresa para el contrato: solo aplican a persona moral.
    if (empresaEl) empresaEl.hidden = (tipo !== 'moral');
    if (correoLabelEl) {
      correoLabelEl.textContent = tipo === 'fisica' ? (t.correoLabelFisica || '') : (t.correoLabelMoral || '');
    }
  }
  tipoInputs.forEach(function (input) {
    input.addEventListener('change', applyTipoVisibility);
  });
  applyTipoVisibility();

  // ── Fiscal prellenado (lazy, una sola vez) ──────────────────────────────
  function renderFiscal(d) {
    fiscalBodyEl.textContent = '';
    var found = d && d.found !== false && (d.razon_social || d.rfc || d.cp_fiscal);
    if (!found) {
      var wrap = document.createElement('div');
      var title = document.createElement('p');
      title.className = 'pp-credsol__fiscal-missing-title';
      title.textContent = t.fiscalMissingTitle || '';
      var body = document.createElement('p');
      body.className = 'pp-credsol__fiscal-missing-body';
      body.textContent = t.fiscalMissingBody || '';
      var cta = document.createElement('a');
      cta.className = 'pp-credsol__fiscal-missing-cta';
      cta.href = FISCAL_PAGE_URL;
      cta.target = '_blank';
      cta.rel = 'noopener';
      cta.textContent = t.fiscalMissingCta || '';
      wrap.appendChild(title);
      wrap.appendChild(body);
      wrap.appendChild(cta);
      fiscalBodyEl.appendChild(wrap);
      return;
    }
    var dl = document.createElement('dl');
    dl.className = 'pp-credsol__fiscal-rows';
    [
      [t.razonSocial, d.razon_social],
      [t.rfc, d.rfc],
      [t.cpFiscal, d.cp_fiscal]
    ].forEach(function (pair) {
      var row = document.createElement('div');
      row.className = 'pp-credsol__fiscal-row';
      var dt = document.createElement('dt');
      dt.textContent = pair[0] || '';
      var dd = document.createElement('dd');
      dd.textContent = pair[1] || '—';
      row.appendChild(dt);
      row.appendChild(dd);
      dl.appendChild(row);
    });
    var note = document.createElement('p');
    note.className = 'pp-credsol__fiscal-note';
    note.textContent = t.fiscalFoundNote || '';
    fiscalBodyEl.appendChild(dl);
    fiscalBodyEl.appendChild(note);
  }

  function loadFiscalOnce() {
    if (fiscalLoaded) return;
    fiscalLoaded = true;
    get(FISCAL_PATH).then(function (d) { renderFiscal(d); }).catch(function () { renderFiscal(null); });
  }

  // ── Dropzones: click, teclado, drag&drop, validación ────────────────────
  function docKeyOf(el) { return el.getAttribute('data-pp-credsol-doc'); }

  function setDocError(docEl, msg) {
    var errEl = docEl.querySelector('[data-pp-credsol-doc-error]');
    if (msg) {
      docEl.setAttribute('data-error', '1');
      if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
    } else {
      docEl.removeAttribute('data-error');
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    }
  }

  // ── Correo del representante ────────────────────────────────────────────
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function setCorreoError(msg) {
    if (!correoInput) return;
    if (msg) {
      correoInput.setAttribute('aria-invalid', 'true');
      if (correoErrorEl) { correoErrorEl.textContent = msg; correoErrorEl.hidden = false; }
    } else {
      correoInput.removeAttribute('aria-invalid');
      if (correoErrorEl) { correoErrorEl.hidden = true; correoErrorEl.textContent = ''; }
    }
  }

  function validateCorreo() {
    if (!correoInput) return null;
    var value = correoInput.value.trim();
    if (!value) return t.errCorreoRequerido;
    if (!EMAIL_RE.test(value)) return t.errCorreoInvalido;
    return null;
  }

  if (correoInput) {
    correoInput.addEventListener('input', function () { setCorreoError(null); });
  }

  function setFileStatus(docEl, label, tone) {
    var statusEl = docEl.querySelector('[data-pp-credsol-file-status]');
    if (!statusEl) return;
    if (!label) { statusEl.hidden = true; return; }
    statusEl.textContent = label;
    statusEl.hidden = false;
    statusEl.setAttribute('data-tone', tone || 'ok');
  }

  function showPreview(docEl, file) {
    var dropzone = docEl.querySelector('[data-pp-credsol-dropzone]');
    var preview = docEl.querySelector('[data-pp-credsol-preview]');
    var nameEl = docEl.querySelector('[data-pp-credsol-file-name]');
    var sizeEl = docEl.querySelector('[data-pp-credsol-file-size]');
    if (dropzone) dropzone.hidden = true;
    if (preview) preview.hidden = false;
    if (nameEl) nameEl.textContent = file.name;
    if (sizeEl) sizeEl.textContent = fmtSize(file.size);
    setFileStatus(docEl, '', null);
  }

  function hidePreview(docEl) {
    var dropzone = docEl.querySelector('[data-pp-credsol-dropzone]');
    var preview = docEl.querySelector('[data-pp-credsol-preview]');
    if (dropzone) dropzone.hidden = false;
    if (preview) preview.hidden = true;
  }

  function validateFile(file) {
    if (ALLOWED_MIME.indexOf(file.type) === -1) return t.errMimeInvalido;
    if (file.size > MAX_SIZE) return t.errSizeExcedido;
    return null;
  }

  function acceptFile(docEl, key, file) {
    var err = validateFile(file);
    if (err) {
      files[key] = null;
      hidePreview(docEl);
      setDocError(docEl, err);
      return;
    }
    files[key] = file;
    setDocError(docEl, null);
    showPreview(docEl, file);
  }

  docEls.forEach(function (docEl) {
    var key = docKeyOf(docEl);
    var dropzone = docEl.querySelector('[data-pp-credsol-dropzone]');
    var input = docEl.querySelector('[data-pp-credsol-file-input]');
    var removeBtn = docEl.querySelector('[data-pp-credsol-file-remove]');
    if (!dropzone || !input) return;

    input.addEventListener('change', function () {
      if (input.files && input.files[0]) acceptFile(docEl, key, input.files[0]);
    });

    // Accesibilidad de teclado: el <label> envuelve el input, pero solo
    // clicks nativos disparan el file picker — Enter/Space en el label
    // enfocado (tabindex=0) necesitan disparo explícito.
    dropzone.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        input.click();
      }
    });

    dropzone.addEventListener('dragover', function (e) {
      e.preventDefault();
      dropzone.classList.add('is-dragover');
    });
    dropzone.addEventListener('dragleave', function () {
      dropzone.classList.remove('is-dragover');
    });
    dropzone.addEventListener('drop', function (e) {
      e.preventDefault();
      dropzone.classList.remove('is-dragover');
      var dropped = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (dropped) acceptFile(docEl, key, dropped);
    });

    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        files[key] = null;
        input.value = '';
        hidePreview(docEl);
        setDocError(docEl, null);
      });
    }
  });

  // ── Banner global ────────────────────────────────────────────────────────
  function showBanner(msg, tone) {
    if (!bannerEl) return;
    bannerEl.textContent = msg;
    bannerEl.hidden = !msg;
    if (tone) bannerEl.setAttribute('data-tone', tone);
    else bannerEl.removeAttribute('data-tone');
  }

  // ── Validación cliente (espejo de validateSubmission del server) ───────
  function validateClient() {
    var tipo = currentTipo();
    var firstInvalid = null;
    var correoErr = validateCorreo();
    if (correoErr) {
      setCorreoError(correoErr);
      firstInvalid = correoInput;
    } else {
      setCorreoError(null);
    }
    docEls.forEach(function (docEl) {
      var aplica = docEl.getAttribute('data-aplica');
      var requerido = docEl.getAttribute('data-requerido') === 'true';
      var aplicaAqui = (aplica === 'ambos' || aplica === tipo);
      var key = docKeyOf(docEl);
      if (aplicaAqui && requerido && !files[key]) {
        setDocError(docEl, t.docMissing);
        if (!firstInvalid) firstInvalid = docEl;
      } else if (aplicaAqui) {
        // Limpia error previo de "falta" si ya se resolvió (no toca errores
        // de mime/size, esos se limpian en acceptFile()).
        if (docEl.getAttribute('data-error') === '1' && files[key]) setDocError(docEl, null);
      }
    });
    if (!privacyInput.checked) {
      showBanner(t.errPrivacidad, 'error');
      if (!firstInvalid) firstInvalid = privacyInput;
    }
    return firstInvalid;
  }

  // ── Respuesta del server: 422 validacion (errors[]) ─────────────────────
  function codeToDocMessage(err) {
    switch (err.code) {
      case 'falta_requerido': return t.docMissing;
      case 'mime_invalido': return t.errMimeInvalido;
      case 'size_excedido': return t.errSizeExcedido;
      default: return t.errGeneric;
    }
  }

  function applyServerValidationErrors(errors) {
    var firstInvalid = null;
    (errors || []).forEach(function (err) {
      if (err.code === 'tipo_persona_invalido') {
        showBanner(t.errTipoInvalido, 'error');
        return;
      }
      var docEl = docEls.filter(function (el) { return docKeyOf(el) === err.tipo; })[0];
      if (docEl) {
        setDocError(docEl, codeToDocMessage(err));
        if (!firstInvalid) firstInvalid = docEl;
      }
    });
    return firstInvalid;
  }

  function focusEl(el) {
    if (!el) return;
    try {
      var focusable = el.querySelector ? (el.querySelector('input, button, [tabindex]') || el) : el;
      focusable.focus({ preventScroll: false });
      if (el.scrollIntoView) el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    } catch (_e) { /* no-op */ }
  }

  // ── Éxito total / parcial ────────────────────────────────────────────────
  function showFullSuccess() {
    form.hidden = true;
    successEl.hidden = false;
    // El título/cuerpo de éxito ya traen su copy final desde el Liquid
    // (| t) — el caso "éxito total" no necesita override de JS. Solo el
    // caso parcial (207 con fallidos) usa copy dinámico, vía markPartial().
    // Revela el aviso "en revisión" que pp-credito.js dejó listo (su propia
    // lectura de estado ya corrió antes de este submit) y oculta el CTA.
    root.hidden = true;
    var revisionEl = document.querySelector('[data-pp-eleg-revision]');
    if (revisionEl) revisionEl.hidden = false;
  }

  function markPartial(subidos, fallidos) {
    (subidos || []).forEach(function (tipo) {
      var docEl = docEls.filter(function (el) { return docKeyOf(el) === tipo; })[0];
      if (docEl) setFileStatus(docEl, t.fileUploaded, 'ok');
    });
    var firstInvalid = null;
    (fallidos || []).forEach(function (f) {
      var docEl = docEls.filter(function (el) { return docKeyOf(el) === f.tipo; })[0];
      if (docEl) {
        setDocError(docEl, t.errUploadFailed);
        if (!firstInvalid) firstInvalid = docEl;
      }
    });
    showBanner(t.successPartialBody, 'warn');
    focusEl(firstInvalid);
  }

  // ── Submit ────────────────────────────────────────────────────────────────
  function setSubmitting(isSubmitting) {
    submitBtn.disabled = isSubmitting;
    if (submitTextEl) submitTextEl.textContent = isSubmitting ? (t.submitting || '') : (t.submit || '');
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    showBanner('', null);

    var firstInvalid = validateClient();
    if (firstInvalid) { focusEl(firstInvalid); return; }

    var fd = new FormData();
    fd.append('tipo_persona', currentTipo());
    fd.append('privacidad_aceptada', 'true');
    fd.append('correo_representante', correoInput ? correoInput.value.trim() : '');
    // Datos de la empresa para el contrato (solo moral, todos opcionales). Se
    // mandan solo los que el cliente llenó; el edge trata vacío como ausente y el
    // ejecutivo los valida/completa en el CRM.
    if (currentTipo() === 'moral' && empresaEl) {
      [
        'representante_legal',
        'escritura_numero', 'escritura_fecha', 'escritura_notario_nombre',
        'escritura_notario_numero', 'escritura_ciudad', 'escritura_folio_mercantil',
        // Escritura del poder del representante (Sara 2026-08-05): por separado.
        'poder_escritura_numero', 'poder_escritura_fecha', 'poder_escritura_notario_nombre',
        'poder_escritura_notario_numero', 'poder_escritura_ciudad', 'poder_escritura_folio_mercantil'
      ].forEach(function (name) {
        var input = empresaEl.querySelector('[name="' + name + '"]');
        var val = input ? input.value.trim() : '';
        if (val) fd.append(name, val);
      });
    }
    docEls.forEach(function (docEl) {
      var key = docKeyOf(docEl);
      if (files[key]) fd.append('doc_' + key, files[key]);
    });

    setSubmitting(true);

    fetch(ENDPOINT, { method: 'POST', credentials: 'same-origin', body: fd })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (json) {
          return { status: res.status, json: json };
        });
      })
      .then(function (r) {
        var status = r.status, json = r.json || {};
        if (status === 200 && json.ok) {
          showFullSuccess();
          return;
        }
        if (status === 207 && json.ok) {
          if (json.fallidos && json.fallidos.length) {
            markPartial(json.subidos, json.fallidos);
          } else {
            showFullSuccess();
          }
          return;
        }
        if (status === 422 && json.code === 'validacion') {
          var firstBad = applyServerValidationErrors(json.errors);
          showBanner(t.errGeneric, 'error');
          focusEl(firstBad);
          return;
        }
        if (status === 422 && json.code === 'correo_representante_invalido') {
          setCorreoError(t.errCorreoInvalido);
          showBanner(t.errGeneric, 'error');
          focusEl(correoInput);
          return;
        }
        var messages = {
          privacidad_no_aceptada: t.errPrivacidad,
          sin_empresa: t.errSinEmpresa,
          member_revoked: t.errMemberRevoked
        };
        showBanner(messages[json.code] || t.errGeneric, 'error');
      })
      .catch(function () {
        showBanner(t.errGeneric, 'error');
      })
      .finally(function () {
        setSubmitting(false);
      });
  });

  // ── Apertura / cierre del modal ──────────────────────────────────────────
  function openModal() {
    loadFiscalOnce();
    showBanner('', null);
    try { modal.showModal(); } catch (_e) { modal.setAttribute('open', ''); }
  }
  function closeModal() {
    try { modal.close(); } catch (_e) { modal.removeAttribute('open'); }
  }

  openBtn.addEventListener('click', openModal);
  Array.prototype.forEach.call(closeEls, function (el) {
    el.addEventListener('click', function (ev) { ev.preventDefault(); closeModal(); });
  });
  if (doneBtn) doneBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });
  // <dialog> dispara 'cancel' con Esc — blindamos por si el browser no
  // lo maneja o algún otro handler global lo intercepta.
  modal.addEventListener('cancel', function (e) {
    e.preventDefault();
    closeModal();
  });

  // Safety: si el customizer o algún preview deja el <dialog> abierto de
  // entrada, ciérralo (mismo patrón defensivo que pp-customer-fiscal.js).
  try { if (modal.open && typeof modal.close === 'function') modal.close(); } catch (_e) { /* no-op */ }

  // ── Visibilidad del CTA: SOLO state === 'elegible' ──────────────────────
  get(CREDITO_PATH).then(function (d) {
    if (d && d.state === 'elegible') root.hidden = false;
  }).catch(function () { /* se queda oculto */ });
})();
